import styled from 'styled-components';
import {
  FilterType,
  CommercialBankData,
  InternetBankData,
  LocalBankData,
  SpecialBankData,
  SecuritiesCompanyData,
  InsuranceCompanyData,
  SavingsBankData,
  MutualFinanceData,
  CreditSpecializedCompanyData,
  TrustCompanyData,
  LoanCompanyData,
  SecuritizationSpecializedCompanyData,
  OnlineInnvestmentFinancialBusiness,
  NonghyupData,
  KFCCData,
  SuhyupData,
} from '../FilterData';

import { useEffect, useState } from 'react';

interface Props {
  filters: FilterType;
  setFilters: (value: FilterType) => void;
}

const HoldingCompany = ({ filters, setFilters }: Props) => {
  const [allSelected1, setAllSelected1] = useState<boolean>(false);
  const [allSelected2, setAllSelected2] = useState<boolean>(false);
  const [allSelected3, setAllSelected3] = useState<boolean>(false);
  const [allSelected4, setAllSelected4] = useState<boolean>(false);
  const [allSelected5, setAllSelected5] = useState<boolean>(false);
  const [allSelected6, setAllSelected6] = useState<boolean>(false);
  const [allSelected7, setAllSelected7] = useState<boolean>(false);
  const [allSelected8, setAllSelected8] = useState<boolean>(false);
  const [allSelected9, setAllSelected9] = useState<boolean>(false);

  useEffect(() => {
    setAllSelected1(
      CommercialBankData.every((item) =>
        filters.multiHoldingCompany.includes(item.name),
      ),
    );
    setAllSelected2(
      LocalBankData.every((item) =>
        filters.multiHoldingCompany.includes(item.name),
      ),
    );
    setAllSelected3(
      InternetBankData.every((item) =>
        filters.multiHoldingCompany.includes(item.name),
      ),
    );
    setAllSelected4(
      SpecialBankData.every((item) =>
        filters.multiHoldingCompany.includes(item.name),
      ),
    );
    setAllSelected5(
      MutualFinanceData.every((item) =>
        filters.multiHoldingCompany.includes(item.name),
      ),
    );
    setAllSelected6(
      CreditSpecializedCompanyData.every((item) =>
        filters.multiHoldingCompany.includes(item.name),
      ),
    );
    setAllSelected7(
      NonghyupData.every((item) =>
        filters.multiHoldingCompany.includes(item.name),
      ),
    );
    setAllSelected8(
      KFCCData.every((item) => filters.multiHoldingCompany.includes(item.name)),
    );
    setAllSelected9(
      SuhyupData.every((item) =>
        filters.multiHoldingCompany.includes(item.name),
      ),
    );
  }, [filters]);

  const toggleFilter = (value: string) => {
    setFilters({
      ...filters,
      holdingCompany: [],
      multiHoldingCompany: filters.multiHoldingCompany.includes(value)
        ? filters.multiHoldingCompany.filter((v) => v !== value)
        : [...filters.multiHoldingCompany, value],
    });
  };

  const toggleAllSelect = (
    state: boolean,
    data: { name: string; value: string }[],
  ) => {
    if (state) {
      setFilters({
        ...filters,
        holdingCompany: [],
        multiHoldingCompany: filters.multiHoldingCompany.filter(
          (name) => !data.some((bank) => bank.name === name),
        ),
      });
    } else {
      setFilters({
        ...filters,
        holdingCompany: [],
        multiHoldingCompany: Array.from(
          new Set([
            ...filters.multiHoldingCompany,
            ...data.map((bank) => bank.name),
          ]),
        ),
      });
    }
  };

  console.log(
    'filters.multiHoldingCompany.length',
    filters.multiHoldingCompany.length,
  );

  return (
    <AllOptionBox>
      <AllOptionBoxContent>
        <BlockContainer>
          <AllSelectBox>
            <img
              onClick={() => {
                setFilters({
                  ...filters,
                  holdingCompany: [],
                  multiHoldingCompany:
                    filters.holdingCompany.length === 0 ? [] : [],
                });
                setAllSelected1(false);
                setAllSelected2(false);
                setAllSelected3(false);
                setAllSelected4(false);
                setAllSelected5(false);
                setAllSelected6(false);
                setAllSelected7(false);
                setAllSelected8(false);
                setAllSelected9(false);
              }}
              src={`/assets/images/check/${
                ((filters.holdingCompany.length === 0 ||
                  filters.holdingCompany[0] === '전체') &&
                  filters.multiHoldingCompany.length === 0) ||
                filters.multiHoldingCompany.length === 43
                  ? 'signUpcheckOn.svg'
                  : 'signUpcheckOff.svg'
              }`}
            ></img>
            <div>전체선택</div>
          </AllSelectBox>
        </BlockContainer>
        <BlockContainer>
          <div>은행</div>
          <Block>
            <BlockTitle>시중은행</BlockTitle>
            <BlockContent>
              <OptionItem
                onClick={() =>
                  toggleAllSelect(allSelected1, CommercialBankData)
                }
              >
                <img
                  src={`/assets/images/check/${allSelected1 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>시중은행 전체</span>
              </OptionItem>
              {CommercialBankData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
          <Block>
            <BlockTitle>지방은행</BlockTitle>
            <BlockContent>
              <OptionItem
                onClick={() => toggleAllSelect(allSelected2, LocalBankData)}
              >
                <img
                  src={`/assets/images/check/${allSelected2 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>지방은행 전체</span>
              </OptionItem>
              {LocalBankData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
          <Block>
            <BlockTitle>인터넷은행</BlockTitle>
            <BlockContent>
              <OptionItem
                onClick={() => toggleAllSelect(allSelected3, InternetBankData)}
              >
                <img
                  src={`/assets/images/check/${allSelected3 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>인터넷은행 전체</span>
              </OptionItem>
              {InternetBankData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
          <Block>
            <BlockTitle>특수은행</BlockTitle>
            <BlockContent>
              <OptionItem
                onClick={() => toggleAllSelect(allSelected4, SpecialBankData)}
              >
                <img
                  src={`/assets/images/check/${allSelected4 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>특수은행 전체</span>
              </OptionItem>
              {SpecialBankData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        </BlockContainer>
        <BlockContainer>
          <div>비은행</div>
          <Block>
            <BlockTitle>증권</BlockTitle>
            <BlockContent>
              {SecuritiesCompanyData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
          <Block>
            <BlockTitle>보험</BlockTitle>
            <BlockContent>
              {InsuranceCompanyData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
          <Block>
            <BlockTitle>저축은행</BlockTitle>
            <BlockContent>
              {SavingsBankData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
          <Block>
            <BlockTitle>상호금융</BlockTitle>
            <BlockContent>
              <OptionItem
                onClick={() => toggleAllSelect(allSelected5, MutualFinanceData)}
              >
                <img
                  src={`/assets/images/check/${allSelected5 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>상호금융 전체</span>
              </OptionItem>
              {MutualFinanceData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
          <Block>
            <BlockTitle>여전사</BlockTitle>
            <BlockContent>
              <OptionItem
                onClick={() =>
                  toggleAllSelect(allSelected6, CreditSpecializedCompanyData)
                }
              >
                <img
                  src={`/assets/images/check/${allSelected6 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>여전사 전체</span>
              </OptionItem>
              {CreditSpecializedCompanyData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        </BlockContainer>
        <BlockContainer>
          <div>기타</div>
          <Block>
            <BlockTitle>신탁</BlockTitle>
            <BlockContent>
              {TrustCompanyData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>

          <Block>
            <BlockTitle>대부업체</BlockTitle>
            <BlockContent>
              {LoanCompanyData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
          <Block>
            <BlockTitle>유동화전문유한회사</BlockTitle>
            <BlockContent>
              {SecuritizationSpecializedCompanyData.map(
                (item: any, index: number) => (
                  <OptionItem
                    key={index}
                    onClick={() => toggleFilter(item.name)}
                  >
                    <img
                      src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                      alt="Check"
                    />
                    <span>{item.name}</span>
                  </OptionItem>
                ),
              )}
            </BlockContent>
          </Block>
          <Block>
            <BlockTitle>온라인투자연계금융업</BlockTitle>
            <BlockContent>
              {OnlineInnvestmentFinancialBusiness.map(
                (item: any, index: number) => (
                  <OptionItem
                    key={index}
                    onClick={() => toggleFilter(item.name)}
                  >
                    <img
                      src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                      alt="Check"
                    />
                    <span>{item.name}</span>
                  </OptionItem>
                ),
              )}
            </BlockContent>
          </Block>
        </BlockContainer>
        <BlockContainer>
          <div>범농협</div>
          <Block>
            <BlockContent>
              <OptionItem
                onClick={() => toggleAllSelect(allSelected7, NonghyupData)}
              >
                <img
                  src={`/assets/images/check/${allSelected7 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>범농협 전체</span>
              </OptionItem>
              {NonghyupData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        </BlockContainer>
        <BlockContainer>
          <div>범새마을금고</div>
          <Block>
            <BlockContent>
              <OptionItem
                onClick={() => toggleAllSelect(allSelected8, KFCCData)}
              >
                <img
                  src={`/assets/images/check/${allSelected8 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>범새마을금고 전체</span>
              </OptionItem>
              {KFCCData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        </BlockContainer>
        <BlockContainer style={{ borderBottom: 'none' }}>
          <div>범수협</div>
          <Block>
            <BlockContent>
              <OptionItem
                onClick={() => toggleAllSelect(allSelected9, SuhyupData)}
              >
                <img
                  src={`/assets/images/check/${allSelected9 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>범수협 전체</span>
              </OptionItem>
              {SuhyupData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.multiHoldingCompany.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        </BlockContainer>
      </AllOptionBoxContent>
    </AllOptionBox>
  );
};
export default HoldingCompany;

const AllSelectBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: #222222;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
`;

const AllOptionBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 2px;
  border: 1px solid #e1e2e4;
  border-radius: 8px;
`;

const AllOptionBoxContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const BlockContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  color: #171e26;
  padding: 12px;
  border-bottom: 1px solid #e8e9ea;
`;

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  color: rgba(23, 30, 38, 0.78);
`;
const BlockContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
`;
const OptionItem = styled.div`
  display: flex;
  width: calc((100% - 8px) / 2);
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  gap: 8px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
  white-space: nowrap;
`;

const BlockTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
`;
